import { Box } from '@jfs/ui-new'
import { Dimensions, useWindowDimensions, ViewStyle } from 'react-native'
import { TableComponent } from '../../../comps/TableComponent'
import { VoiceboxBTItem } from './VoiceboxBTItem'
const VoiceBoxBTCarousal = ({ data, mid }) => {
  const width = useWindowDimensions().width
  if (!data || data.length === 0) {
    return null
  }
  const renderItem = ({ item }: any) => {
    return <VoiceboxBTItem data={item} mid={mid} />
  }
  return (
    <Box justify={'space-between'}>
      <TableComponent
        value={''} //Routes value
        canFetchMore={false}
        hide={false}
        isCustom={true}
        ListContent={data ?? []}
        horizontal={true}
        RenderCustomElement={renderItem}
        contentContainerStyle={styles.listContainerStyle}
        customStyle={styles.flatListStyle}
        keyExtractor={(item) => item.dsn}
        snapToInterval={width - 36}
        decelerationRate={'fast'}
        snapToAlignment="start"
      />
    </Box>
  )
}

const { width } = Dimensions.get('screen')
const styles = {
  flatListStyle: { flexGrow: 0, backgroundColor: 'WHITE', width: width } as ViewStyle,
  listContainerStyle: { flexGrow: 0, alignSelf: 'center', paddingBottom: 16, paddingRight: 16 } as ViewStyle,
}

export { VoiceBoxBTCarousal }
